import { useEffect } from 'react'
import { WebsocketEvent } from 'entities/WebSocket/store'
import type { IResponseEventInboxMemberRemoved } from 'entities/Inbox/api/types'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { type GroupInbox } from 'entities/Inbox/model/GroupInbox'
import type { ConversationMenuStore } from 'pages/conversations/ui/ConversationMenu'

export const useEventInboxMemberRemoved = (
  store: ConversationMenuStore,
  groupInbox: GroupInbox
) => {
  const { inboxesStore, websocket } = useEntitiesContext()
  const handle = (data: IResponseEventInboxMemberRemoved) => {
    const inboxIdChild = data.id

    if (groupInbox.teamsIds.includes(inboxIdChild)) {
      inboxesStore.deleteItemFromGroup(groupInbox.id, inboxIdChild)

      if (!groupInbox.teamsIds.length) {
        store.handleDeleteTeamsGroupsById(groupInbox)
      }
    }
  }

  useEffect(() => websocket.on(WebsocketEvent.InboxMemberRemoved, handle), [])
}
